import { MATERIAL_API } from "./apiConfig";
//import { MATERIAL_DATA_JSON } from "./assets/material-data";

const timeRegLimit = 30 * 24 * 60 * 60 * 1000; //30 dias

if (!window.indexedDB) {
	//window.alert("Your browser doesn't support a stable version of IndexedDB.")
}

//let DB_GEN = null;
//let DB_SAVE = null;

function inicializarDB() {
	return new Promise((resolve, reject) => {
		let dbrequest = indexedDB.open("db_centro_plus", 2);

		dbrequest.onupgradeneeded = function(event) {
			// triggers if the client had no database
			//console.info("DB onupgradeneeded");
			let db = event.target.result;

			db.createObjectStore("db_centro_plus", {
				keyPath: "id",
				autoIncrement: false,
			});

			resolve(db);
			//DB_SAVE = DB_GEN.createObjectStore("data-save", { keyPath: "id", autoIncrement: false });
		};

		dbrequest.onerror = function(e) {
			//console.error("Error DB_SAVE", e);
			reject(e);
		};

		dbrequest.onsuccess = function() {
			//console.info("DB onsuccess");
			let db = dbrequest.result;
			db.transaction(["db_centro_plus"], "readwrite");

			resolve(db);
			//DB_SAVE = DB_GEN.transaction(["data-save"], "readwrite");
			// continue to work with database using db object
		};
	});
}

function setDataModule(key, obj_data) {
	inicializarDB().then((db) => {
		let objectStore = db
			.transaction(["db_centro_plus"], "readwrite")
			.objectStore("db_centro_plus");

		let dataToUp = {
			id: key,
			time: new Date(),
			data: obj_data,
		};
		let requestUpdate = objectStore.put(dataToUp);

		requestUpdate.onerror = function() {
			// Do something with the error
			//console.error("Error en update data2");
		};
		requestUpdate.onsuccess = function() {
			// Success - the data is updated!
			//console.log("Datos actualizados!2 ", event.result);
		};
	});
}

function getDataModule(key, time_limit, url_api) {
	return new Promise((resolve, reject) => {
		inicializarDB()
			.then((db) => {
				let objectStore = db
					.transaction(["db_centro_plus"], "readonly")
					.objectStore("db_centro_plus");
				let getTransaction = objectStore.get(key);

				getTransaction.onerror = function() {
					//console.error("DB error getTransaction");
					reject();
				};

				getTransaction.onsuccess = function() {
					let data = getTransaction.result;
					if (data) {
						//Data Recueperada
						/*console.info(
							"Data Recueperada: ",
							data,
							data.time.getTime() + time_limit > new Date().getTime(),
							!navigator.onLine
						);*/

						if (
							data.time.getTime() + time_limit > new Date().getTime() ||
							!navigator.onLine
						) {
							//Timepo No Vencido o NoOnline con data guardada vieja
							//console.warn("Data no vencida");
							resolve(data.data);
						} else {
							//Tiempo Vencido => Actualizar y enlinea
							//console.warn("Data vencida");
							if (navigator.onLine) {
								getDataFromApi(url_api)
									.then((datosGetted) => {
										//Actualizamos

										let dataToUp = {
											id: key,
											time: new Date(),
											data: datosGetted,
										};

										objectStore = db
											.transaction(["db_centro_plus"], "readwrite")
											.objectStore("db_centro_plus");
										let requestUpdate = objectStore.put(dataToUp);

										requestUpdate.onerror = function() {
											// Do something with the error
											//console.error("Error en update data");
											reject();
										};
										requestUpdate.onsuccess = function() {
											// Success - the data is updated!
											//console.log("Datos actualizados! ", event.result);
											resolve(datosGetted);
										};
									})
									.catch(() => resolve([]));
							} else {
								//Vencida pero sin internet
								//console.warn("Vencida pero sin internet");
								resolve(data);
							}
						}
					} else {
						//Datos no encontrados
						//console.error("Datos no encontrados!");
						getDataFromApi(url_api)
							.then((datos) => {
								//Guardamos datos
								let saveTrans = db
									.transaction(["db_centro_plus"], "readwrite")
									.objectStore("db_centro_plus")
									.add({
										id: key,
										time: new Date(),
										data: datos,
									});

								saveTrans.onsuccess = function() {
									//console.info("Datos guardados correctamente");
									resolve(datos);
								};
							})
							.catch(() => resolve([]));
					}
				};
			})
			.catch((e) => console.error("Error InicializandoDB ", e));
	});
}

function formatCsvToJson(textData) {
	let lines = textData.split("\n");
	//console.log("Lines ", lines);

	let result = [];

	lines.slice(1).map((item) => {
		let raw = item.split(",");
		let carrera = raw[0];
		let materia = raw[1];
		let link = raw[2];

		result.push({
			carrera: carrera,
			recurso: "Carpeta",
			titulo: materia,
			tipo: "Digital",
			link: link,
		});
	});

	//console.log("Result ", result);

	return result;
}

function getDataFromApi(URL) {
	//Sorry, It's a bypass in Material Case

	if (URL == MATERIAL_API) {
		return new Promise((resolve, reject) => {
			console.warn("Fetching data material");
			fetch(URL)
				.then((response) => response.text())
				.then((datos) => {
					//console.log("Solicitando datos...", datos);

					let result = formatCsvToJson(datos);
					resolve(result);
				})
				.catch((error) => {
					//Error de conexion (posible)
					console.error("Algo paso ", error);
					reject([]);
				});
		});
	} else {
		return new Promise((resolve, reject) => {
			console.log("Fetching data");
			fetch(URL)
				.then((response) => response.json())
				.then((datos) => {
					//console.log("Solicitando datos...", datos);
					resolve(datos);
				})
				.catch((error) => {
					//Error de conexion (posible)
					console.error("Algo paso ", error);
					reject([]);
				});
		});
	}
}

function getSaveData(nameData) {
	return new Promise((resolve, reject) => {
		inicializarDB()
			.then((DB_GEN) => {
				let saveTrans = DB_GEN.transaction(["db_centro_plus"], "readonly")
					.objectStore("db_centro_plus")
					.get(nameData);

				saveTrans.onerror = function() {
					//console.error("DB error");
					reject();
				};

				saveTrans.onsuccess = function() {
					let data = saveTrans.result;
					if (data) {
						//console.info("Data Recueperada: ", data);
						resolve(data);
					} else {
						//console.error("Datos no encontrados!");
						reject();
					}
				};
			})
			.catch((e) => {
				reject(e);
				//console.log("ERROR ", e);
			});
	});
}

//LOCAl-STORAGE
function setData(id, obj) {
	localStorage.setItem(id, JSON.stringify(obj));
}

function getUserDataLocal() {
	//console.log("Getting userData");
	let userData = JSON.parse(localStorage.getItem("@user_data"));
	if (userData && (userData.date + timeRegLimit >= new Date().getTime() || !navigator.onLine)) {
		//Data no vencida
		//console.warn("No vencida");
		return userData;
	} else {
		//console.warn("Vencida");
		return null;
	}
}

function deleteUserDataLocal() {
	//console.log("Deleting userData");
	localStorage.removeItem("@user_data");
}

function setUserDataLocal(data) {
	//console.log("Setting userData");
	setData("@user_data", { user: data, date: new Date().getTime() });
}

export {
	inicializarDB,
	getDataModule,
	setDataModule,
	getSaveData,
	setUserDataLocal,
	deleteUserDataLocal,
	getUserDataLocal,
};
